import React from 'react';

import {Client, TokenManager} from '../../redux/utils/index';
import {Login} from './Login';
import {clearLoginError} from "../../redux/users/userActions";

import {firebaseAuth} from "../../firebase";

import {Redirect} from 'react-router-dom';
import {connect} from "react-redux";

class LoginContainer extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			username: "",
			password: "",
			logged: false
		};
		this.client = new Client();
	}

	onError(error) {
		this.setState({
			loading: false,
			error: error
		});
	}

	onSubmit = (e) => {
		e.preventDefault();
		this.setState({loading: true, error: null, logged: false});
		this.props.clearLoginError();
		this.login();
	};

	usernameListener = (e) => {
		this.setState({username: e.target.value});
	};

	passwordListener = (e) => {
		this.setState({password: e.target.value});
	};

	login = () => {
		firebaseAuth.signInWithEmailAndPassword(this.state.username, this.state.password)
			.then(() => {
				this.setState({logged: true});
			})
			.catch((error) => {
				// Handle Errors here.
				let errorMessage = error.message;
				this.setState({
					loading: false,
					error: errorMessage
				});
			});
	};

	render() {
		if (this.state.logged || this.props.logged) {
			return <Redirect to={"/dashboard"}/>;
		} else {
			return <Login isLoading={this.state.loading}
			              error={this.state.error || this.props.loginError}
			              username={this.state.username}
			              onUsernameChange={this.usernameListener}
			              password={this.state.password}
			              onPasswordChange={this.passwordListener}
			              onSubmit={this.onSubmit}/>;
		}
	}
}

function mapStateToProps({users}) {

	return {
		ready: users.ready,
		logged: users.isLogged,
		loginError: users.loginError
	};
}

const mapDispatchToProps = {clearLoginError};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);